import { FC } from "react";
import { Button, Form } from "antd";
import { formItemLayout } from "const/formItemLayout";
import { FormattedMessage, useIntl } from "react-intl";
import PhoneNumberField from "components/fields/PhoneNumberField";

import { FormProps } from "./types";
import { usePhoneNumberValidators } from "./hooks";

const LoginForm: FC<FormProps> = ({ loading }) => {
  const intl = useIntl();
  const phoneNumberValidators = usePhoneNumberValidators();

  return (
    <>
      <Form.Item
        label={intl.formatMessage({
          defaultMessage: "Phone number",
        })}
        name="phoneNumber"
        rules={phoneNumberValidators}
        className="custom-form-label"
        {...formItemLayout}
      >
        <PhoneNumberField />
      </Form.Item>
      <Form.Item {...formItemLayout}>
        <Button
          htmlType="submit"
          type="primary"
          size="large"
          block
          {...{ loading }}
        >
          <FormattedMessage defaultMessage="Next" />
        </Button>
      </Form.Item>
    </>
  );
};

export default LoginForm;
